export default __webpack_public_path__ + "static/media/project-feast.f7c10a46.jpg";